/* ============================================================
   Spot Essence · Blog editorial (Diario) — JS de artículo
   Recuperado del diseño original 2026-05-25 (blog-premium-diario).
   - Barra de progreso de lectura (+ hitos GA4)
   - Índice (TOC) auto-generado de los títulos, con scrollspy
   - Anclas "#" en cada título (hover desktop / sutil mobile)
   - Índice sticky: sidebar en desktop, cajón inferior en mobile (≡)
   - Compartir (copiar/WhatsApp)
   Se auto-protege: si no hay artículo, no hace nada.
   ============================================================ */
(function () {
  var body = document.querySelector('[data-article-body]');
  if (!body) return;
  var content = body.querySelector('.article-content.rte') || body;

  /* ----- Barra de progreso (0% arriba → 100% abajo; se oculta si el
     artículo es muy corto para que no se vea lleno de entrada) ----- */
  function initProgressBar() {
    var bar = document.querySelector('.blog-progress');
    if (!bar) return;
    var ticking = false;
    function update() {
      var rect = body.getBoundingClientRect();
      var scrollY = window.scrollY || window.pageYOffset;
      var top = rect.top + scrollY;
      var vh = window.innerHeight;
      var scrollable = body.offsetHeight - vh;
      if (scrollable < vh * 0.4) { bar.style.display = 'none'; ticking = false; return; }
      var pct = Math.max(0, Math.min(100, ((scrollY - top) / scrollable) * 100));
      bar.style.width = pct + '%';
      if (pct >= 50 && !body.dataset.gaScroll50) {
        body.dataset.gaScroll50 = '1';
        if (window.gtag) gtag('event', 'blog_scroll_50', { article_handle: body.dataset.articleHandle });
      }
      if (pct >= 90 && !body.dataset.gaScrollComplete) {
        body.dataset.gaScrollComplete = '1';
        if (window.gtag) gtag('event', 'blog_scroll_complete', { article_handle: body.dataset.articleHandle });
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function slugify(txt, i) {
    var s = (txt || '').toLowerCase().trim()
      .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
      .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
      .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return s || ('seccion-' + (i + 1));
  }

  /* ----- TOC + anclas + scrollspy ----- */
  function initTOC() {
    var containers = document.querySelectorAll('[data-toc-container]');
    if (!containers.length) return;
    var levels = (containers[0].getAttribute('data-toc-levels') || 'h2').split(',')
      .map(function (l) { return l.trim(); }).join(',');
    var headings = content.querySelectorAll(levels);

    if (!headings.length) {
      // sin títulos: ocultar todo el TOC
      document.querySelectorAll('[data-toc-root]').forEach(function (el) { el.style.display = 'none'; });
      return;
    }

    var used = {};
    var items = []; // {id, text, tag}
    Array.prototype.forEach.call(headings, function (h, i) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent, i);
        if (used[id]) id = id + '-' + (i + 1);
        h.id = id;
      }
      used[id] = true;
      // ancla "#" (el glifo va en CSS ::after para no ensuciar el texto del título ante crawlers)
      if (!h.querySelector('.heading-anchor')) {
        h.classList.add('has-anchor');
        var a = document.createElement('a');
        a.className = 'heading-anchor';
        a.href = '#' + id;
        a.setAttribute('aria-label', 'Enlace a esta sección');
        h.appendChild(a);
      }
      items.push({ id: id, text: h.textContent.replace(/#$/, '').trim(), tag: h.tagName.toLowerCase() });
    });

    // construir lista en cada container (desktop + drawer)
    Array.prototype.forEach.call(containers, function (container) {
      var ul = document.createElement('ul');
      ul.className = 'blog-toc__list';
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'blog-toc__item blog-toc__item--' + it.tag;
        li.dataset.targetId = it.id;
        var a = document.createElement('a');
        a.href = '#' + it.id;
        a.textContent = it.text;
        a.addEventListener('click', function () {
          if (window.gtag) gtag('event', 'blog_toc_click', { target: it.id });
        });
        li.appendChild(a);
        ul.appendChild(li);
      });
      container.appendChild(ul);
    });

    // scrollspy
    var allItems = document.querySelectorAll('.blog-toc__item');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          allItems.forEach(function (it) {
            it.classList.toggle('blog-toc__item--active', it.dataset.targetId === entry.target.id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
    Array.prototype.forEach.call(headings, function (h) { observer.observe(h); });
  }

  /* El índice mobile es una tarjeta <details> inline (toggle nativo, sin JS). */

  /* ----- Compartir ----- */
  function initShare() {
    document.querySelectorAll('[data-share-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.shareAction;
        var url = window.location.href;
        var title = document.title;
        switch (action) {
          case 'copy':
            navigator.clipboard.writeText(url).then(function () {
              btn.classList.add('copied');
              var prev = btn.textContent;
              btn.textContent = '✓ Copiado';
              setTimeout(function () { btn.classList.remove('copied'); btn.textContent = prev; }, 1500);
            });
            break;
          case 'whatsapp':
            window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url));
            break;
          case 'email':
            window.location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
            break;
        }
        if (window.gtag) gtag('event', 'blog_share', { network: action });
      });
    });
  }

  function init() {
    initProgressBar();
    initTOC();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
